<app-menu-toggle
  tooltip="Info panel"
  icon="info-panel"
  [active]="showInfoPanel"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
